import { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import balance_icon from "@/images/service/balance_icon.png";
import { useUserInfo } from "@/model";
import { serviceApi } from "@/apis";
import Capital from "./comonents/Capital";
import Tables from "./comonents/Tables";
import "./index.less";

const Balance = () => {
  const userInfo = useUserInfo();
  const [segmentOption, setSegmentOption] = useState<DictionarySelectOption[]>(
    []
  );
  const [curSegment, setCurSegment] = useState("");

  useEffect(() => {
    if (!userInfo.curUserInfo) return;
    getFindByUserCode(userInfo.curUserInfo.userCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.curUserInfo]);

  // 获取销售视图
  const getFindByUserCode = useCallback(async (userCode: string) => {
    try {
      const res = await serviceApi.findByUserCode({
        userCode,
      });
      if (res.salesView) {
        const saleArr: SalesView[] = [];
        res.salesView.forEach(({ salesOrganization, productGroup }) => {
          saleArr.push({
            salesOrganization,
            productGroup,
          });
        });
        getSegment(saleArr);
      }
    } catch (error: any) {
      message.error(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 查询授信获取信用段
  const getSegment = useCallback(async (saleArr: SalesView[]) => {
    try {
      const res = await serviceApi.customerSales(saleArr);
      const segmentArr: DictionarySelectOption[] = [];
      res && res.forEach(({ salesOrganizationName, code }) => {
        segmentArr.push({
          label: salesOrganizationName,
          value: code,
        });
      });
      // segmentArr.push({
      //   value: "001",
      //   label: "测试",
      // });
      setSegmentOption(segmentArr);
      setCurSegment(segmentArr[0].value);
    } catch (error: any) {
      message.error(error);
    }
  }, []);

  return (
    <div className="balance-wrapper">
      <div className="center-main-title">
        <img src={balance_icon} alt="" />
        <h3>应付账款</h3>
      </div>
      <div className="balance-content">
        <Capital
          segmentOption={segmentOption}
          curSegment={curSegment}
          setCurSegment={setCurSegment}
          customerCode={userInfo.curUserInfo?.customerCode}
          customerName={userInfo.curUserInfo?.customerName}
        />
        <Tables
          curSegment={curSegment}
          customerCode={userInfo.curUserInfo?.customerCode}
        />
      </div>
    </div>
  );
};

export default Balance;
